import axios from "axios";

const URL   = "https://api.spartan.com.br";
//const URL = "http://192.168.110.252:9000";

const api = axios.create({
    baseURL : URL,
    auth:{
        username:"spartanws",
        password:"5p@rt@nw3b!"
    }
});

export default api;

